import React from 'react';
import PlannerFrame from './PlannerFrame';

const TruckBookingPlanner = () => {
  return (
    <PlannerFrame
      title="Truck Booking Predictor"
      src="/truck-booking-predictor.html"
    />
  );
};

export default TruckBookingPlanner;